// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_soM_8","title":"Card_title_QwXRZ","body":"Card_body_85uX5","count":"Card_count_3tXci"};